import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { formatMoney, AFGHAN_MONTHS } from '../utils/api';

export default function Sales() {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [year, setYear] = useState(now.getFullYear());

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/sales?month=${month}&year=${year}`);
      setSales(data);
    } catch {}
    setLoading(false);
  };
  useEffect(() => { load(); }, [month, year]);

  const shamsiYear = year - 621;

  return (
    <div>
      <div className="page-header">
        <h1>مدیریت فروشات</h1>
        <button className="btn btn-primary" onClick={() => navigate('/sales/new')}>➕ فروش جدید</button>
      </div>

      {/* فیلتر ماه */}
      <div className="card" style={{ marginBottom: 16, padding: '14px 20px' }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>فیلتر ماه:</span>
          <select className="form-control" style={{ width: 140 }} value={month} onChange={e => setMonth(e.target.value)}>
            {AFGHAN_MONTHS.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
          </select>
          <select className="form-control" style={{ width: 110 }} value={year} onChange={e => setYear(e.target.value)}>
            {[2024, 2025, 2026].map(y => <option key={y} value={y}>{y - 621}</option>)}
          </select>
          <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>
            {AFGHAN_MONTHS[month - 1]} {shamsiYear} — {sales.length} فروش
          </span>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>در حال بارگذاری...</div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>شماره فاکتور</th><th>مشتری</th><th>تاریخ</th><th>مجموع</th><th>پرداخت شده</th><th>باقی</th><th>فروشنده</th><th>عملیات</th></tr>
              </thead>
              <tbody>
                {sales.map(s => (
                  <tr key={s.id}>
                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{s.invoice_number}</td>
                    <td>{s.first_name ? `${s.first_name} ${s.last_name}` : <span style={{ color: 'var(--text-muted)' }}>نقدی</span>}</td>
                    <td style={{ fontSize: 12 }}>{new Date(s.sale_date).toLocaleDateString('fa-AF')}</td>
                    <td style={{ fontWeight: 600 }}>{formatMoney(s.total_amount)}</td>
                    <td style={{ color: 'var(--success)' }}>{formatMoney(s.paid_amount)}</td>
                    <td>
                      {Number(s.debt_amount) > 0
                        ? <span className="badge badge-danger">{formatMoney(s.debt_amount)}</span>
                        : <span className="badge badge-success">تسویه</span>}
                    </td>
                    <td style={{ fontSize: 12 }}>{s.seller_name}</td>
                    <td>
                      <button className="btn btn-outline btn-sm" onClick={() => navigate(`/sales/${s.id}`)}>📄 جزئیات</button>
                    </td>
                  </tr>
                ))}
                {sales.length === 0 && <tr><td colSpan={8} style={{ textAlign: 'center', padding: 32, color: 'var(--text-muted)' }}>فروشی در این ماه وجود ندارد</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
